const ua = navigator.userAgent.toLocaleLowerCase();
window.COURSE_WEBSOCKET = null;
window.isApp = ua.indexOf('kidslearning_inapp_web') > -1 || ua.indexOf('kidslearning_vipbingo_web') > -1 ? true : false;
window.canSocket = window.isApp && ua.indexOf('1.0.0') === -1 ? true : false;
window.messageFun = {}; // 绑定事件列表
window.webSocketPort = 13080;
let bridgeTimer = null;
let callbackList = {};

function wsBridge(cb) {

    if (!window.canSocket) return;

    if (!window.COURSE_WEBSOCKET || (window.COURSE_WEBSOCKET && window.COURSE_WEBSOCKET.readyState === 3)) {    // 连接已经关闭或者根本没有建立。
        putaoWS.startWebSocket(cb);
    } else if (window.COURSE_WEBSOCKET.readyState === 1) {  // 连接成功建立，可以进行通信。
        cb && typeof cb === "function" && cb();
    } else if (window.COURSE_WEBSOCKET.readyState === 0) {  // 正在建立连接连接，还没有完成。
        bridgeTimer = setTimeout(() => {
            wsBridge(cb);
        }, 50);
    }
}

// 获取app返回的 WEBSOCKET
function getMessage(type, cb) {
    if (window.messageFun && window.messageFun[type] && window.COURSE_WEBSOCKET) {
        window.COURSE_WEBSOCKET.removeEventListener("message", window.messageFun[type], false);
    }

    window.messageFun[type] = function (mes) {
        try {
            let wsData = mes.data;
            wsData = JSON.parse(wsData);
            if (wsData && wsData.type === type) {
                let callback = (wsData.content && wsData.content.mid && callbackList[wsData.content.mid])
                    || cb;
                // cb && typeof cb === "function" && cb(wsData.content);
                callback && typeof callback === "function" && callback(wsData.content);
            }
        } catch (err) {
            console.log('===getMessage catch===', err)
        }
    }

    wsBridge(() => {
        window.COURSE_WEBSOCKET.addEventListener("message", window.messageFun[type], false);
    });
}

export class putaoWS {

    /**
     * 建立WebSocket连接
     */
    static startWebSocket(cb, port) {

        if (!window.canSocket) return;

        if (port) {
            window.webSocketPort = port;
        }

        if (!window.COURSE_WEBSOCKET || (window.COURSE_WEBSOCKET && window.COURSE_WEBSOCKET.readyState === 3)) {
            window.COURSE_WEBSOCKET = new WebSocket(`ws://127.0.0.1:${window.webSocketPort}`);
        }

        // 发送
        window.COURSE_WEBSOCKET.onopen = function () {
            window.COURSE_WEBSOCKET.send(JSON.stringify({ type: 'ready' }));
            putaoWS.createHttpServer();
            setTimeout(function () {
                cb && typeof cb === "function" && cb();
            }, 1000)
            // cb && typeof cb === "function" && cb();
        };

        // 通信发生错误时触发
        window.COURSE_WEBSOCKET.onerror = function (e) {
            console.log(e);
        };

        // 连接关闭时触发
        window.COURSE_WEBSOCKET.onclose = function () {
            console.log('WebSocket已关闭');
        };

    }

    /**
     * 发送WebSocket数据
     */
    static sendWebSocket(data, cb) {
        if (cb && typeof cb === 'function') {
            let mid = Math.ceil(Math.random() * 10000000);  // 生成一个唯一id
            data.mid = mid;
            callbackList[mid] = cb;
        }
        console.log('===sendWebSocket===', data)
        wsBridge(() => {
            window.COURSE_WEBSOCKET.send(JSON.stringify(data));
        });
    }

    /**
     * 关闭WebSocket连接
     */
    static closeWebSocket() {
        if (window.canSocket && window.COURSE_WEBSOCKET && window.COURSE_WEBSOCKET.readyState !== 3) {
            window.COURSE_WEBSOCKET.close();
        }
    }


    // 开始下载
    static startDownload(lessons, cb, failCb) {
        if (!(lessons && lessons.length)) {
            failCb && typeof failCb === "function" && failCb({ "code": -1000, "msg": "下载列表空" });
            return;
        }
        if (!navigator.onLine) {
            failCb && typeof failCb === "function" && failCb({ "code": -1002, "msg": "请检查网络连接！" });
            return;
        }
        let _progress = 0;
        this.sendWebSocket({
            type: 'download',
            content: {
                lessons: lessons,
            }
        });
        console.log("===download===")
        getMessage("sendDownloadProgress", (content) => {
            if (content && content.progress) {
                _progress = content.progress;
            }
            cb && typeof cb === "function" && cb(content);
        });
        setTimeout(() => {
            _progress === 0 && failCb && typeof failCb === "function" && failCb({ "code": -1001, "msg": "下载超时，请重试！" });
        }, 30000);
    }

    // 是否处于下载中
    static getDownloadStatus(cb) {
        this.sendWebSocket({
            type: 'getDownloadStatus',
        });
        getMessage("sendDownloadStatus", (content) => {
            cb && typeof cb === "function" && cb(content.status);
        });
    }

    // 获取某个cid的下载进度
    static getCidDownloadProgress(cid, cb) {
        if (!cid) return;
        this.sendWebSocket({
            type: 'getCidDownloadProgress',
            content: { cid: cid }
        });
        getMessage("sendCidDownloadProgress", (content) => {
            console.log("===getCidDownloadProgress===", content)
            cb && typeof cb === "function" && cb(content);
        });
    }

    // 停止下载
    static stopDownload() {
        console.log('====stopDownload===')
        this.sendWebSocket({
            type: 'stopDownload',
        });
    }

    // 判断视频是否存在
    static getVideoIsExist(url, cb) {
        console.log('====getVideoIsExist===')
        this.sendWebSocket({
            type: 'getVideoIsExist',
            content: { url: url }
        });
        getMessage("sendVideoIsExist", (content) => {
            cb && typeof cb === "function" && cb(content.isExist);
        });
    }


    // 获取app的目录
    static getAppDirname(cb) {
        this.sendWebSocket({
            type: 'getAppDirname'
        });
        getMessage("sendAppDirname", (content) => {
            cb && typeof cb === "function" && cb(content);
        });
    }

    // 删除所有视频
    static deleteAllVideo(cb) {
        this.sendWebSocket({
            type: 'deleteAllVideo'
        });
        getMessage("sendDeleteAllVideoSize", (content) => {
            cb && typeof cb === "function" && cb(content);  // content.size 返回字节数，转为M：content.size/1024/1024
        });
    }


    /**
     * 启动http服务
     */
    static createHttpServer() {
        wsBridge(() => {
            window.COURSE_WEBSOCKET.send(JSON.stringify({ type: 'createHttpServer' }));
        });
    }

    static stopHttpServer() {
        wsBridge(() => {
            window.COURSE_WEBSOCKET.send(JSON.stringify({ type: 'stopHttpServer' }));
        });
    }


    /**
     * 录屏相关
     */

    static startRecordScreen(args) {
        this.sendWebSocket({
            type: 'startRecordScreen',
            content: args
        });
    }

    static stopRecordScreen(args) {
        this.sendWebSocket({
            type: 'stopRecordScreen',
            content: args
        });
    }


    // 关闭客户端
    static closeClient() {
        console.log('===closeClient====')
        this.sendWebSocket({
            type: 'closeClient'
        });
    }

    // 获取硬件信息
    static getOsInfo(cb) {
        this.sendWebSocket({
            type: 'getOsInfo'
        }, cb);
        getMessage("sendOsInfo");
    }

}


// WEBPACK FOOTER //
// ./src/lib/ws.js